"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basePath = void 0;
exports.fetchData = fetchData;
exports.host = exports.getQueryParams = exports.getItemLocation = void 0;
var _logger = require("../logger");
var _catchPromiseError = require("./catchPromiseError");
var _getUrl = require("./getUrl");
const utilityName = 'yandexGeocodingSearch';
const catchError = async promise => (0, _catchPromiseError.catchPromiseError)(promise, `Error in ${utilityName}`);
const basePath = exports.basePath = '1.x';
const host = exports.host = 'https://geocode-maps.yandex.ru';
const getQueryParams = (searchText, {
  mapAccount: {
    credentials
  }
}, maxDisplayedSearchResults) => ({
  // TO-DO: lang: localeString, // 'cs', 'en-GB', looks like only selected subset of standard locales is supported
  apikey: credentials,
  results: maxDisplayedSearchResults,
  geocode: searchText,
  format: 'json'
});
exports.getQueryParams = getQueryParams;
const getItemLocation = pos => {
  const split = pos.split(' ');
  return {
    latitude: Number(split[0]),
    longitude: Number(split[1])
  };
};
exports.getItemLocation = getItemLocation;
const transformData = data => {
  (0, _logger.logDebug)(`${utilityName} transformData(): data before transformation:\n\t`, data);
  const results = (data?.response.GeoObjectCollection.featureMember ?? []).map((item, index) => {
    const {
      GeoObject: {
        Point: {
          pos: position
        },
        metaDataProperty: {
          name,
          GeocoderMetaData: {
            Address: {
              formatted: label
            }
          }
        }
      }
    } = item;
    return {
      id: `${name} | ${index}`,
      label,
      position: getItemLocation(position)
    };
  });
  (0, _logger.logInfo)(`${utilityName}: loaded data after transformation:\n\t`, results);
  return {
    results
  };
};
async function fetchData(options) {
  (0, _logger.logInfo)(`${utilityName}: Loading data ...`);
  const promise = catchError((0, _getUrl.getUrl)({
    ...options
  }));
  const data = await promise;
  return transformData(data);
}